import { Link } from 'react-router-dom';
import Logo from '@/pages/home/components/Logo';
import { APPLY_URL } from '@/pages/home/config';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Results', to: '/results' },
];

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms', href: '/terms' },
  { label: 'Disclaimer', href: '/disclaimer' },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Logo />
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-xs">
              Marketing strategy and growth consulting for established local and
              home-service businesses ready to turn spend into measurable
              revenue.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950">
              Navigate
            </h4>
            <nav className="mt-4 flex flex-col gap-3">
              {navLinks.map((l) => (
                <Link
                  key={l.label}
                  to={l.to}
                  className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">
                  {l.label}
                </Link>
              ))}
              <a
                href={APPLY_URL}
                className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">
                Apply
              </a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950">
              Connect
            </h4>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://www.facebook.com/profile.php?id=61578187042513"
                rel="nofollow noopener"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-white/10 text-foreground-600 hover:border-primary-500 hover:text-primary-400 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/joshuawhastings/"
                rel="nofollow noopener"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-white/10 text-foreground-600 hover:border-primary-500 hover:text-primary-400 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@joshuahastingscoach"
                rel="nofollow noopener"
                aria-label="YouTube"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-white/10 text-foreground-600 hover:border-primary-500 hover:text-primary-400 transition-colors">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} HFE Marketing Group LLC. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {/* {legalLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
                {l.label}
              </a>
            ))} */}
          </div>
        </div>
      </div>
    </footer>
  );
}
